import * as React from "react";
import * as SelectPrimitive from "@radix-ui/react-select";
import clsx from "clsx";
import { SharedIcon } from "./shared-icon";

const SelectRoot = SelectPrimitive.Root;
const SelectTrigger = SelectPrimitive.Trigger;
const SelectIcon = SelectPrimitive.Icon;
const SelectPortal = SelectPrimitive.Portal;
const SelectContent = SelectPrimitive.Content;
const SelectViewport = SelectPrimitive.Viewport;
const SelectLabel = SelectPrimitive.Label;
const SelectGroup = SelectPrimitive.Group;
const SelectSeparator = SelectPrimitive.Separator;

const SelectValue = React.forwardRef(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <span className={clsx("shadcn-select-value", className)}>
        <SelectPrimitive.Value {...props} ref={forwardedRef}>
          {children}
        </SelectPrimitive.Value>
      </span>
    );
  }
);

const SelectItem = React.forwardRef(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <SelectPrimitive.Item
        className={clsx("shadcn-select-item", className)}
        {...props}
        ref={forwardedRef}
      >
        <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
        <SelectPrimitive.ItemIndicator className="shadcn-select-item-indicator">
          <SharedIcon
            iconName="#sprite-icon-tick"
            style={{ width: "17px", height: "17px" }}
          />
        </SelectPrimitive.ItemIndicator>
      </SelectPrimitive.Item>
    );
  }
);

const SelectScrollUpButton = React.forwardRef(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <SelectPrimitive.ScrollUpButton
        className={clsx("shadcn-select-scroll-button", className)}
        {...props}
        ref={forwardedRef}
      >
        {children}
        <SharedIcon
          iconName="#sprite-icon-dropdown-arrow"
          style={{
            width: "14px",
            height: "14px",
            transform: "rotate(180deg)",
            transformOrigin: "center",
          }}
        />
      </SelectPrimitive.ScrollUpButton>
    );
  }
);

const SelectScrollDownButton = React.forwardRef(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <SelectPrimitive.ScrollDownButton
        className={clsx("shadcn-select-scroll-button", className)}
        {...props}
        ref={forwardedRef}
      >
        {children}
        <SharedIcon
          iconName="#sprite-icon-dropdown-arrow"
          style={{
            width: "14px",
            height: "14px",
          }}
        />
      </SelectPrimitive.ScrollDownButton>
    );
  }
);

export {
  SelectRoot,
  SelectTrigger,
  SelectValue,
  SelectIcon,
  SelectPortal,
  SelectContent,
  SelectScrollUpButton,
  SelectViewport,
  SelectLabel,
  SelectGroup,
  SelectSeparator,
  SelectScrollDownButton,
  SelectItem,
};
